import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import EmploymentSubMenu from '@/components/nav/EmploymentSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExitPopup941 from '@/components/ui/ExitPopup941';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Form941 = () => {
  const [open, setOpen] = useState(false);
  const [referralUrl, SetReferralUrl] = useState('form941');
  const [closeSticky, setCloseSticky] = useState<boolean>(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Stay on top of your payroll tax responsibilities`,
  //   SubHeading:
  //     '<span style="font-weight:500; color:#333;" >E-file Form 941 Now to save time and reduce stress.</span>',
  //   CtaText: 'E-file Form 941 Now!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941sticky`,
  //   isActive: true,
  // };
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());
  const handleStickyClose = (): void => {
    setCloseSticky(true);
  };

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 7, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 7, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  useEffect(() => {
    const isIRSPageReferral = document.referrer === 'https://www.irs.gov/';
    if (isIRSPageReferral) SetReferralUrl('form941irs');
  });
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1,
            pt: 0.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 60, md: 60 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 20 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.2 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 10 },
            fontWeight: 500,
            color: '#ccc',
            mt: 0,
            mx: -1,
            mb: -1,
            py: 0.2,
            px: { xs: 0, sm: 0, lg: 0 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  const [isvideoPopup, setvideoPopup] = useState(false);
  const openPopup = () => {
    setvideoPopup(true);
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File Form 941 Online for the 2026 Tax Year"
          description="File Form 941 online with TaxZerone for the 2026 tax year to report quarterly payroll taxes, federal withholdings, Social Security, & Medicare taxes to the IRS"
          keywords="Form 941, Form 941 Online, Payroll Taxes, E-file Form 941"
          canonical="employment-tax/e-file-irs-form-941/"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
          ogShareImg="assets/images/employment-share-img.png"
        />
      }
    >
      <Hidden smDown>
        {!closeSticky && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong>
                      Ready to file your quarterly payroll tax return?
                    </strong>{' '}
                    <br />
                    E-file Form 941 (Q3) for 2026 now.
                  </Typography>
                </Box>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden>
              </Stack>
            </Container>
          </Box>
        )}
      </Hidden>

      <Box
        itemScope
        itemType="https://schema.org/VideoObject"
        sx={{
          display: 'contents',
        }}
      >
        <meta
          itemProp="name"
          content="Streamline Your Form 941 Filing with TaxZerone.com: A Step-by-Step Guide"
        />

        <meta
          itemProp="description"
          content="Learn how to streamline your Form 941 filing with TaxZerone.com in this step-by-step guide. This video explains how to prepare and e-file Form 941 online, helping employers accurately report quarterly federal payroll taxes and complete the filing process with ease."
        />

        <meta
          itemProp="thumbnailUrl"
          content="https://img.youtube.com/vi/8KUp9tZMNp8/maxresdefault.jpg"
        />

        <meta itemProp="uploadDate" content="2024-03-28T00:00:00+00:00" />

        <meta
          itemProp="embedUrl"
          content="https://www.youtube.com/embed/8KUp9tZMNp8"
        />

        <VideoPopup
          isvideoPopup={isvideoPopup}
          setvideoPopup={setvideoPopup}
          src="https://www.youtube.com/embed/8KUp9tZMNp8?autoplay=1&rel=0"
        />
      </Box>

      <ExitPopup941 />
      {/* isPriceView1099s={false}
        setIsPriceView1099s={function (value: SetStateAction<boolean>): void {
          throw new Error('Function not implemented.');
        }} */}
      <EmploymentSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Last Day to E-File Forms 941!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>final day</b> to
              electronically file your <b>Form 941</b> (Employer&apos;s
              Quarterly Federal Tax Return).
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Stack
        component="section"
        direction={{ xs: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="center"
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          position: { xs: 'relative', sm: 'sticky' },
          background: 'linear-gradient(135deg, #0a7581, #0d2b2f)',
          p: 1.5,
          px: 2.5,
          color: '#fff',
          minHeight: 40,
          left: 0,
          right: 0,
          zIndex: 11,
          textAlign: 'center',
          top: { xs: 0, sm: 114, md: 118 },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#cbcbcb',
            lineHeight: 1.3,
            fontSize: { xs: 14, sm: 16, md: 18, lg: 20 },
          }}
        >
          <span style={{ fontWeight: 'bold', color: '#f2ff35' }}>
            📢 Attention Employers!
          </span>{' '}
          E-file{' '}
          <span style={{ fontWeight: 600, color: '#ffffff' }}>
            Form 941 (Q3-2026)
          </span>{' '}
          Today to Report Your{' '}
          <span style={{ fontWeight: 600, color: '#ffffff' }}>
            Quarterly Payroll Taxes.
          </span>
        </Typography>
        <Button
          variant="contained"
          size="small"
          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941`}
          sx={{
            backgroundColor: '#fff',
            '&:hover, &:focus': {
              backgroundColor: '#0a7581',
              color: '#fff',
              // backgroundColor: '#213e99',
              // color: '#fff',
            },
            minWidth: 90,

            px: 2,
            py: 0.5,
            color: '#333',
            mt: { xs: 0, md: 0 },
            display: { xs: 'inline-block', sm: 'inline-block' },
            mx: { xs: 'auto', sm: 1 },
            borderRadius: 2,
            boxShadow: 'none',
            fontSize: { xs: 12, sm: 14, md: 16 },
            textTransform: 'none',
          }}
        >
          E-file Now
        </Button>
      </Stack>
      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #0a7581, #0d2b2f)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                color: '#efefefd5',
                lineHeight: 1.3,
              }}
            >
              <strong>⏳ Time Is Running Out!</strong> E-file your 2025
              <b style={{ fontWeight: 600, color: '#fcf6bd' }}>
                {' '}
                Form 941 (Q4)
              </b>{' '}
              today to report your quarterly payroll taxes.
            </Typography>
            <Box>
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography>
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#0a7581',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container> */}
      <Container
        maxWidth="xl"
        component="section"
        sx={{ mt: { sm: 3, md: 3 } }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            {/* <Box component={'div'}> */}
            <Box
              sx={{
                mt: { xs: 2, sm: 3, md: 2, lg: 0 },
                mb: { xs: 2, sm: 2, md: 2, lg: 4 },
              }}
            >
              {/* <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'left',
                    mb: { xs: 1, sm: 1.5 },
                    lineHeight: 1.3,
                  }}
                >
                  Time left to file before the deadline(
                  <span style={{ fontWeight: 600 }}>
                    31<sup>st</sup> Jan 2025
                  </span>
                  ):
                </Typography>
                <Countdown date={lastDayTaxSeason} renderer={renderer} />
              </Box> */}
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 941</span>
                </span>{' '}
                Online for 2026 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                E-file your Employer’s Quarterly Federal Tax Return (Form 941)
                in minutes with our IRS-authorized platform. Stay compliant,
                avoid penalties, and file confidently every quarter.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                  >
                    File Form 941 Now
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              {/* <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              >
                <Box
                  sx={{
                    background: '#333',
                    p: 1,
                    px: 2,
                    color: '#fff',
                    '&.ribbon:before': { left: 0 },
                    '&.ribbon:after': { right: 0 },
                  }}
                  className="ribbon"
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: { xs: 'center', sm: 'center' },
                        fontSize: { xs: 16, sm: 18, md: 20 },
                      }}
                    >
                      Form 941 for Quarter 1, 2024, is due on{' '}
                      <strong>April 30</strong>
                    </Typography>
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Box>
          <Box
            itemScope
            itemType="https://schema.org/ImageObject"
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
              width: '100%',
            }}
          >
            {/* Non-visible metadata */}
            <meta
              itemProp="name"
              content="E-File IRS Form 941 Online for 2026 Tax Year"
            />
            <link
              itemProp="contentUrl"
              href="https://www.taxzerone.com/assets/images/941-landing-img.webp"
            />

            <picture style={{ marginBottom: -7 }}>
              <source
                srcSet="/assets/images/941-landing-img.webp"
                type="image/webp"
                width={880}
                height={725}
              />
              <source
                srcSet="/assets/images/941-landing-img.png"
                type="image/png"
                width={880}
                height={725}
              />
              {/* Visible image tag */}
              <img
                itemProp="url"
                src="/assets/images/941-landing-img.png"
                alt="E-File IRS Form 941 Online for 2026 Tax Year"
                className="img-responsive-banner"
                width={880}
                height={725}
              />
            </picture>
          </Box>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File Form 941 online with the IRS at the lowest price.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                At TaxZerone, we make payroll compliance quick, simple, and
                affordable for small to large businesses
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              E-file for just
              <br />
              <Box
                component="strong"
                sx={{
                  color: '#ffe400',
                  fontSize: { xs: 30, sm: 36, md: 48, lg: 60 },
                }}
              >
                $6.99
              </Box>
              <Typography
                variant="body2"
                sx={{ mt: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                Transparent pricing with no hidden fees
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is Form 941?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Form 941,{' '}
                  <span style={{ fontWeight: 600 }}>
                    Employer&apos;s Quarterly Federal Tax Return
                  </span>
                  , is utilized by businesses to report the federal income tax
                  withheld, wages paid, and both the employees&apos; and
                  employers&apos; share of Social Security and Medicare taxes.
                  It also addresses any tip, sick pay, and group-term life
                  insurance adjustments to have employers report and pay their
                  federal payroll taxes regularly each quarter.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                  maxHeight: 432,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/form-941-detail-img.webp" />
                  <source srcSet="/assets/images/form-941-detail-img.png" />
                  <img
                    src="/assets/images/form-941-detail-img.png"
                    alt="What is Form 941?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={500}
                    height={432}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                  maxHeight: 432,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/form-941-who-file-img.webp" />
                  <source srcSet="/assets/images/form-941-who-file-img.png" />
                  <img
                    src="/assets/images/form-941-who-file-img.png"
                    alt="Who Must File Form 941? "
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={500}
                    height={432}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Who Must File Form 941?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  <span style={{ fontWeight: 600 }}> Employers</span> who pay
                  wages subject to{' '}
                  <span style={{ fontWeight: 600 }}>
                    federal income tax withholding
                  </span>{' '}
                  or{' '}
                  <span style={{ fontWeight: 600 }}>
                    Social Security and Medicare taxes
                  </span>{' '}
                  must file{' '}
                  <span style={{ fontWeight: 600 }}>Form 941 quarterly</span> to
                  report:
                </Typography>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{ mb: 3, color: '#6e6e6e' }}
                >
                  <Box
                    component="ul"
                    sx={{
                      width: '100%',
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    <li
                      style={{
                        marginBottom: 12,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Wages paid</Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Tips from employees reported </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Federal income tax withheld</Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Employer and employee shares of Social Security and
                        Medicare taxes{' '}
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Additional Medicare Tax withheld from employees{' '}
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Fractional cents adjustments, sick pay, tips, and
                        group-term life insurance
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Qualified small business payroll tax credit for
                        increasing research activities
                      </Box>
                    </li>
                  </Box>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  mt: 1,
                  textAlign: 'center',
                }}
              >
                Form 941 Filing Deadlines for 2026
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Deadlines fall on the last day of the month following each
                quarter’s end
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,

                  backgroundColor: '#f0f2f9',
                  // backgroundColor: '#0896ba',
                  // boxShadow:
                  //   'rgba(50, 50, 93, 0.25) 10px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
                  // position: 'relative',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                    // color: '#fff',
                  }}
                >
                  Q1
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}
                >
                  January - March{' '}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                  // className="new-ribbon-941"
                >
                  Due: April 30
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,
                  minHeight: '100%',
                  // backgroundColor: '#f0f2f9',
                  backgroundColor: '#f0f2f9',
                  position: 'relative',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Q2
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 600, mb: 2 }}
                >
                  April - June
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                >
                  Due: July 31
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,
                  position: 'relative',
                  minHeight: '100%',
                  color: '#fff',
                  backgroundColor: 'rgb(61, 188, 158)',
                  boxShadow:
                    'rgba(50, 50, 93, 0.25) 10px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  Q3
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}
                >
                  July - September
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                  className="new-ribbon-941"
                >
                  Due: November 2
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,
                  backgroundColor: '#f0f2f9',

                  // backgroundColor: 'rgb(207, 147, 84, 0.95)',
                  // boxShadow:
                  //   'rgba(50, 50, 93, 0.25) 10px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
                  // position: 'relative',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                    // color: '#fff',
                  }}
                >
                  Q4
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 16,
                    // fontWeight: 600,
                    mb: 2,
                    // color: '#efefefff',
                  }}
                >
                  October - December
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                >
                  Due: February 1
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12} sx={{ textAlign: 'center', mt: 2 }}>
              <Box sx={{ maxWidth: 950, width: '100%', margin: 'auto' }}>
                <Typography variant="body1" sx={{ mt: 3 }}>
                  {' '}
                  If you deposit all employment taxes on time, the IRS allows an
                  additional 10 calendar days to file your 941 returns.
                </Typography>
                <Alert
                  severity="warning"
                  id="semi"
                  icon={false}
                  sx={{ mt: 3, mb: 3, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note :</b> If the 941 due date falls on a federal holiday,
                  the filing deadline will be the next business day
                </Alert>
                <Box>
                  {' '}
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      mt: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                  >
                    E-File 941 Now
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        itemScope
        itemType="https://schema.org/HowTo"
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              {/* Directly bound visible h2 to itemProp="name" (removed hidden duplicate Box) */}
              <Typography
                variant="h2"
                itemProp="name"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to File IRS Form 941 for the 2026 Tax Year?
              </Typography>

              <Typography
                variant="body1"
                itemProp="description"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Follow these steps to complete your quarterly payroll tax filing
                with confidence and accuracy.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container maxWidth="lg" sx={{ mb: { xs: 6, sm: 8, md: 10 } }}>
          <Grid container spacing={2} justifyContent="center">
            {/* STEP 1 */}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              itemProp="step"
              itemScope
              itemType="https://schema.org/HowToStep"
            >
              <meta itemProp="position" content="1" />
              <link
                itemProp="image"
                href="https://www.taxzerone.com/assets/images/step-1-icon.png"
              />
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <picture>
                    <source srcSet="/assets/images/step-1-icon.webp" />
                    <source srcSet="/assets/images/step-1-icon.png" />
                    <img
                      src="/assets/images/step-1-icon.png"
                      alt="Enter or Upload your Data"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    variant="h3"
                    itemProp="name"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    Enter or Upload your Data
                  </Typography>
                  <Typography variant="body1" itemProp="text">
                    Enter your payroll data manually or import it in bulk with
                    our Excel template.
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* STEP 2 */}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              itemProp="step"
              itemScope
              itemType="https://schema.org/HowToStep"
            >
              <meta itemProp="position" content="2" />
              <link
                itemProp="image"
                href="https://www.taxzerone.com/assets/images/step-2-icon.png"
              />
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <picture>
                    <source srcSet="/assets/images/step-2-icon.webp" />
                    <source srcSet="/assets/images/step-2-icon.png" />
                    <img
                      src="/assets/images/step-2-icon.png"
                      alt="Pay Any Due Amount and Sign"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    itemProp="name"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    Pay Any Due Amount and Sign
                  </Typography>
                  <Typography variant="body1" itemProp="text">
                    Select your preferred payment method to settle the balance
                    due, e-sign the return, and review the form information to
                    ensure its accuracy.
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* STEP 3 */}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              itemProp="step"
              itemScope
              itemType="https://schema.org/HowToStep"
            >
              <meta itemProp="position" content="3" />
              <link
                itemProp="image"
                href="https://www.taxzerone.com/assets/images/step-3-icon.png"
              />
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <picture>
                    <source srcSet="/assets/images/step-3-icon.webp" />
                    <source srcSet="/assets/images/step-3-icon.png" />
                    <img
                      src="/assets/images/step-3-icon.png"
                      alt="Transmit the return to the IRS"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    itemProp="name"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    Transmit the return to the IRS
                  </Typography>
                  <Typography variant="body1" itemProp="text">
                    Securely submit your Form 941 tax form to the IRS and
                    receive a notification once your return is accepted.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>

          <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
            <Typography
              variant="body1"
              sx={{ mt: 3, mb: 1, fontSize: { md: 18, sm: 16, xs: 16 } }}
            >
              Ready to File Your Quarterly Payroll Tax Return with TaxZerone?
            </Typography>
            <Stack
              spacing={2}
              direction="row"
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignContent: 'center',
                display: 'grid',
                gridTemplateColumns: 'auto auto ',
                mt: 4,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  mt: 0,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
              >
                Start Filing Now
              </Button>
              <Button
                onClick={openPopup}
                sx={{ ml: 2 }}
                className="icon-blink"
                aria-label="video"
              >
                <Box
                  component="img"
                  src="/assets/images/youtube-icon.svg"
                  width={60}
                  height={67}
                  loading="lazy"
                  sx={{}}
                  alt="youtube video"
                />
              </Button>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 4 }}>
          <Grid
            container
            spacing={2}
            sx={{ my: 5 }}
            direction={{ xs: 'column-reverse', md: 'row' }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                m: 'auto',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    mt: 1,
                    textAlign: 'left',
                  }}
                >
                  Common Mistakes on Form 941
                </Typography>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{ mb: 3, color: '#6e6e6e' }}
                >
                  <Box
                    component="ul"
                    sx={{
                      width: '100%',
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    <li
                      style={{
                        marginBottom: 12,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Incorrect tax calculations
                        </span>{' '}
                        <br />
                        Misreporting Social Security, Medicare, or Additional
                        Medicare Tax & Tips.{' '}
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Missing adjustments
                        </span>{' '}
                        <br /> Forgetting to include tips, sick pay, group-term
                        life insurance, or fractions of cents.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Using the wrong form
                        </span>{' '}
                        <br />
                        Filing 941 instead of Form 944 (annual) or Form 943
                        (farm employees).
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Not Filing Zero Returns
                        </span>{' '}
                        <br />
                        You must file every quarter once you start, even with no
                        wages.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Late filing or payment
                        </span>{' '}
                        <br /> Not meeting quarterly deadlines, which can lead
                        to penalties and interest.{' '}
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Incorrect reporting of tax credits
                        </span>{' '}
                        <br />
                        Misreporting qualified small business payroll tax
                        credits.
                      </Box>
                    </li>
                  </Box>
                </Typography>
              </Box>
            </Grid>

            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 0 },
                  mr: { xs: 0, md: 0 },
                  maxHeight: 432,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/form-941-common-img.webp" />
                  <source srcSet="/assets/images/form-941-common-img.png" />
                  <img
                    src="/assets/images/form-941-common-img.png"
                    alt="Common Mistakes on Form 941"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={500}
                    height={432}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 4 }}>
          <Grid container spacing={2} sx={{ my: 5 }}>
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  mt: 1,
                  textAlign: 'center',
                }}
              >
                Affordable Form 941 Filing Pricing for Every Business
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center', mb: 3 }}>
                At TaxZerone, filing Quarter 3 of{' '}
                <span style={{ fontWeight: 600 }}> 941 Form</span> is{' '}
                <span style={{ fontWeight: 600 }}>
                  fast, simple, and affordable
                </span>
                —perfect for businesses of all sizes.
              </Typography>
            </Grid>
            <Grid size={{ md: 5, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                }}
                className="new-price-card"
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mt: 4,
                    zIndex: 2,
                    position: 'relative',
                    alignContent: 'center',
                    p: 2,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { md: 22, sm: 20, xs: 18 },
                      my: 1,
                      color: '#fff',
                    }}
                  >
                    E-File Form 941 for just
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { md: 28, sm: 24, xs: 20 },
                      color: '#f3f3f3',
                    }}
                  >
                    {' '}
                    <Box
                      component="span"
                      sx={{
                        fontSize: { xs: 36, sm: 36, md: 48, lg: 60 },
                        fontWeight: 'bold',
                        color: '#ffe400',
                      }}
                    >
                      {' '}
                      $6.99
                    </Box>
                    /return{' '}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ mb: 2.5, color: '#f3f3f3' }}
                  >
                    <span style={{ fontWeight: 600 }}> Save 10%</span> with our
                    Pay in Advance & Save option{' '}
                  </Typography>
                  <Button
                    size="large"
                    variant="contained"
                    href="/pricing/#employment"
                    sx={{
                      boxShadow: 'none',
                      borderRadius: 2,
                      mb: 0.5,
                      textTransform: 'none',
                      backgroundColor: '#fff',
                      color: '#0a7581',
                      '&:hover, &:focus, &:active': {
                        color: '#fff',
                        backgroundColor: '#1da94a',
                      },
                    }}
                  >
                    E-File Now
                  </Button>
                  <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0' }}>
                    No hidden cost - ever
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ md: 7, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  component="div"
                  variant="body1"
                  sx={{ mb: 3, color: '#6e6e6e' }}
                >
                  <Box
                    component="ul"
                    sx={{
                      width: '100%',
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    <li
                      style={{
                        marginBottom: 12,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Includes{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Schedule B, Form 8974, and Form 8453-EMP
                        </span>
                        <br /> (
                        <span style={{ fontStyle: 'italic' }}>if required</span>
                        )
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Free retransmission of rejected returns</Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Expert US-based support (
                        <span style={{ fontWeight: 600 }}>
                          English & Spanish
                        </span>
                        )
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Instant IRS filing status updates</Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Downloadable copies for your records</Box>
                    </li>
                  </Box>
                </Typography>
              </Paper>
            </Grid>

            <Grid size={12} sx={{ textAlign: 'center' }}>
              <Alert
                severity="info"
                icon={<TipsAndUpdatesIcon />}
                sx={{ mt: 4, maxWidth: 600, mx: 'auto', mb: 0 }}
              >
                Filing early ensures you stay compliant and avoid{' '}
                <Link
                  href="/resources/employment-tax/form-941-penalties"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  IRS penalties
                </Link>
                .
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Powerful Features Designed to Simplify Your Payroll Tax Filing
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Authorized
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}>Authorized by the IRS</span>{' '}
                  to securely process your tax filings with full compliance and
                  trusted accuracy.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Easy Zero Filing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy Zero Filing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    No taxes to report this quarter?
                  </span>{' '}
                  Select{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    &apos;No Taxes to Report&apos;
                  </span>{' '}
                  and{' '}
                  <Link
                    href="https://support.taxzerone.com/how-to-file-a-zero-tax-return-for-form-941-using-taxzerone/"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    file zero 941 return
                  </Link>{' '}
                  quickly with TaxZerone.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Upload "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Upload
                </Typography>
                <Typography variant="body1">
                  Save time with our{' '}
                  <Link
                    href="/resources/employment-tax/form-941-bulk-upload/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    941 bulk upload
                  </Link>{' '}
                  option - import multiple records and file them all at once.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/calculate-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/calculate-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/calculate-icon.png"
                      alt="Smart Calculations "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Calculations
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Automatically calculate
                  </span>{' '}
                  your taxes accurately as you enter data, making filing faster
                  and error-free.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/sign-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/sign-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/sign-icon.png"
                      alt="Authorize/Sign your Return"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Authorize/Sign your Return
                </Typography>
                <Typography variant="body1">
                  Quickly sign your return using Form 8453-EMP or an online PIN.
                  <span style={{ fontStyle: 'italic' }}>
                    {' '}
                    (You can request your{' '}
                    <Link
                      href="/employment-tax/e-file-irs-form-94x-pin-request/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      94x PIN
                    </Link>{' '}
                    for <span style={{ fontWeight: 600 }}> FREE</span>.)
                  </span>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Lowest price"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Lowest price
                </Typography>
                <Typography variant="body1">
                  Get the lowest prices for payroll tax filing while enjoying
                  both accurate filing and expert support.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-access-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-access-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-access-icon.png"
                      alt="Supports Schedule B & Form 8974"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Supports Schedule B & <br />
                  Form 8974
                </Typography>
                <Typography variant="body1">
                  Supports{' '}
                  <Link
                    href="/resources/employment-tax/form-941-schedule-b-filing-requirements/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Schedule B
                  </Link>{' '}
                  for semiweekly deposits and{' '}
                  <Link
                    href="/resources/employment-tax/form-8974-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 8974
                  </Link>{' '}
                  to apply the Qualified Small Business Payroll Tax Credit for
                  Increasing Research Activities
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/multiple-pay-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/multiple-pay-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/multiple-pay-icon.png"
                      alt="Flexible Payment Options"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Flexible Payment Options
                </Typography>
                <Typography variant="body1">
                  Pay your taxes securely via{' '}
                  <Link
                    href="/resources/electronic-funds-withdrawal-efw/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    EFW
                  </Link>
                  ,{' '}
                  <Link href="/resources/eftps/" sx={{ color: '#0202ff' }}>
                    EFTPS
                  </Link>
                  , credit/debit card, or check/money order-choose what works
                  best for you.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Support
                </Typography>
                <Typography variant="body1">
                  Get real help from real people—expert assistance is always
                  available when you need guidance, in both{' '}
                  <span style={{ fontWeight: 600 }}> English and Spanish</span>.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
          {/* <Box sx={{ textAlign: { xs: 'center', md: 'center' }, mb: 5 }}>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
            >
              E-file Form 941 Now
            </Button>
          </Box> */}
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Why TaxZerone Is the #1 Choice for Employers Filing Form 941
              </Typography>

              <Box component="div" sx={{ mb: 4, maxWidth: 900, m: 'auto' }}>
                <TableContainer sx={{ border: '1px solid #828282' }}>
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow
                        sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                      >
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          Feature
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          TaxZerone
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          Other E-file Platforms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          Manual Filing (Paper)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          IRS-Authorized{' '}
                        </TableCell>
                        <TableCell>✅ Yes </TableCell>
                        <TableCell>✅ Yes </TableCell>
                        <TableCell>❌ No </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Real-Time Error Validation
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                            verticalAlign: 'center',
                          }}
                        >
                          ✅ Built-in IRS checks
                        </TableCell>
                        <TableCell>Limited </TableCell>
                        <TableCell>Error-prone </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Bulk Upload Support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Excel template import
                        </TableCell>
                        <TableCell>May charge extra </TableCell>
                        <TableCell>Not available </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Processing Time
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Instant IRS Submission
                        </TableCell>
                        <TableCell>1–2 Days </TableCell>
                        <TableCell>3–6 Weeks </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Free Form 8879-EMP & Form 8453-EMP Signature Option
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Included
                        </TableCell>
                        <TableCell>⚠️ Extra Fee </TableCell>
                        <TableCell>❌ Manual Signature </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Free Retransmission (
                          <span
                            style={{ fontStyle: 'normal', fontWeight: 400 }}
                          >
                            if rejected
                          </span>
                          )
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Yes
                        </TableCell>
                        <TableCell>❌ No </TableCell>
                        <TableCell>❌ No</TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Error Checks & Validation
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Real-Time
                        </TableCell>
                        <TableCell>⚠️ Partial </TableCell>
                        <TableCell>❌ None </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Ease of Use
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ <Box>&nbsp;Step-by-Step Guidance (FREE)</Box>
                        </TableCell>
                        <TableCell>Moderate </TableCell>
                        <TableCell>❌ Complex </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Extra Fees or Hidden Costs
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ No Extra Fees
                        </TableCell>
                        <TableCell>⚠️ Possible </TableCell>
                        <TableCell>❌ None </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Customer Support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',

                            justifyContent: 'center',
                          }}
                        >
                          ✅ Available
                        </TableCell>
                        <TableCell>Limited or outsourced </TableCell>
                        <TableCell>No help available </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          background: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                See How Tax Filing Became Easier for Business Owners
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  mb: { xs: 1, sm: 3 },
                }}
              >
                See why small businesses trust TaxZerone for smooth, simple, and
                reliable tax filing.
              </Typography>

              <Box itemScope itemType="https://schema.org/Product">
                {/* PRODUCT IDENTITY */}
                <meta itemProp="name" content="TaxZerone" />

                {/* AGGREGATE RATING (Required for star snippets in Google) */}
                <Box
                  itemProp="aggregateRating"
                  itemScope
                  itemType="https://schema.org/AggregateRating"
                >
                  <meta itemProp="ratingValue" content="5" />
                  <meta itemProp="reviewCount" content="3" />
                  <meta itemProp="bestRating" content="5" />
                  <meta itemProp="worstRating" content="1" />
                </Box>

                <Grid
                  container
                  spacing={2}
                  m={0}
                  justifyContent="center"
                  direction="row"
                  className="MuiGrid-root-width"
                  sx={{ mb: 3 }}
                >
                  {/* REVIEW 1 */}
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Paper
                      elevation={0}
                      itemScope
                      itemType="https://schema.org/Review"
                      itemProp="review"
                      sx={{
                        background: '#f0f2f9',
                        p: 2,
                        borderRadius: 3,
                        minHeight: '100%',
                      }}
                    >
                      <meta itemProp="datePublished" content="2026-04-03" />

                      {/* Structured Rating */}
                      <Box
                        itemProp="reviewRating"
                        itemScope
                        itemType="https://schema.org/Rating"
                      >
                        <meta itemProp="ratingValue" content="5" />
                        <meta itemProp="bestRating" content="5" />
                        <meta itemProp="worstRating" content="1" />
                      </Box>

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ my: 1 }}
                        justifyContent={{ xs: 'center', md: 'center' }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &ldquo;
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          color="gray"
                          itemProp="reviewBody"
                          sx={{
                            fontSize: { xs: 16, sm: 18, md: 20 },
                            fontFamily: 'san-serif',
                            fontStyle: 'italic',
                            color: '#414042',
                            lineHeight: 1.2,
                          }}
                        >
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Filing is so easy!{' '}
                          </span>{' '}
                          I quickly entered all my payroll info and finished the
                          process without any confusion.
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{ mt: 2 }}
                            justifyContent={{ xs: 'center', md: 'center' }}
                          >
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-1"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-2"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-3"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-4"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-5"
                            />
                          </Stack>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &rdquo;
                        </Typography>
                      </Stack>

                      <Typography
                        variant="body1"
                        itemProp="author"
                        itemScope
                        itemType="https://schema.org/Person"
                        sx={{ fontWeight: 600, textAlign: 'right' }}
                      >
                        -{' '}
                        <Box component="span" itemProp="name">
                          Bill Martin
                        </Box>
                      </Typography>
                    </Paper>
                  </Grid>

                  {/* REVIEW 2 */}
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Paper
                      elevation={0}
                      itemScope
                      itemType="https://schema.org/Review"
                      itemProp="review"
                      sx={{
                        background: '#f0f2f9',
                        p: 2,
                        borderRadius: 3,
                        minHeight: '100%',
                      }}
                    >
                      <meta itemProp="datePublished" content="2026-04-03" />

                      <Box
                        itemProp="reviewRating"
                        itemScope
                        itemType="https://schema.org/Rating"
                      >
                        <meta itemProp="ratingValue" content="5" />
                        <meta itemProp="bestRating" content="5" />
                        <meta itemProp="worstRating" content="1" />
                      </Box>

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ my: 1 }}
                        justifyContent={{ xs: 'center', md: 'center' }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &ldquo;
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          color="gray"
                          itemProp="reviewBody"
                          sx={{
                            fontSize: { xs: 16, sm: 18, md: 20 },
                            fontFamily: 'san-serif',
                            fontStyle: 'italic',
                            color: '#414042',
                            lineHeight: 1.2,
                          }}
                        >
                          <span style={{ fontWeight: 600 }}>
                            {' '}
                            Excellent service!{' '}
                          </span>{' '}
                          It was easy to find what I needed and even easier to
                          fill out the form.
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{ mt: 2 }}
                            justifyContent={{ xs: 'center', md: 'center' }}
                          >
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-1"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-2"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-3"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-4"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-5"
                            />
                          </Stack>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &rdquo;
                        </Typography>
                      </Stack>

                      <Typography
                        variant="body1"
                        itemProp="author"
                        itemScope
                        itemType="https://schema.org/Person"
                        sx={{ fontWeight: 600, textAlign: 'right' }}
                      >
                        -{' '}
                        <Box component="span" itemProp="name">
                          Tonya Sheffield
                        </Box>
                      </Typography>
                    </Paper>
                  </Grid>

                  {/* REVIEW 3 */}
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Paper
                      elevation={0}
                      itemScope
                      itemType="https://schema.org/Review"
                      itemProp="review"
                      sx={{
                        background: '#f0f2f9',
                        p: 2,
                        borderRadius: 3,
                        minHeight: '100%',
                      }}
                    >
                      <meta itemProp="datePublished" content="2026-04-03" />

                      <Box
                        itemProp="reviewRating"
                        itemScope
                        itemType="https://schema.org/Rating"
                      >
                        <meta itemProp="ratingValue" content="5" />
                        <meta itemProp="bestRating" content="5" />
                        <meta itemProp="worstRating" content="1" />
                      </Box>

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ my: 1 }}
                        justifyContent={{ xs: 'center', md: 'center' }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &ldquo;
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          color="gray"
                          itemProp="reviewBody"
                          sx={{
                            fontSize: { xs: 16, sm: 18, md: 20 },
                            fontFamily: 'san-serif',
                            fontStyle: 'italic',
                            color: '#414042',
                            lineHeight: 1.2,
                          }}
                        >
                          I had a great experience filing my payroll taxes with
                          <span style={{ fontWeight: 600 }}> TaxZerone</span>.
                          The platform was easy to use and efficient.
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{ mt: 2 }}
                            justifyContent={{ xs: 'center', md: 'center' }}
                          >
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-1"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-2"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-3"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-4"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-5"
                            />
                          </Stack>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &rdquo;
                        </Typography>
                      </Stack>

                      <Typography
                        variant="body1"
                        itemProp="author"
                        itemScope
                        itemType="https://schema.org/Person"
                        sx={{ fontWeight: 600, textAlign: 'right' }}
                      >
                        -{' '}
                        <Box component="span" itemProp="name">
                          Samella Horsley
                        </Box>
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          background: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                Supporting Forms
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-941-schedule-b-filing-requirements/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    transition: 'all 0.3s ease 0s',
                    borderRadius: 5,
                    height: '100%',
                    backgroundColor: '#fff',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Form 941 Schedule B
                  </Typography>
                  <Typography variant="body1">
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Report of Tax Liability for Semiweekly Schedule Depositors
                      -
                    </span>
                    Required for businesses that deposit employment taxes on a
                    semi-weekly schedule.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-8974-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 5,
                    height: '100%',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Form 8974
                  </Typography>
                  <Typography variant="body1">
                    <span style={{ fontWeight: 600 }}>
                      Qualified Small Business Payroll Tax Credit for Increasing
                      Research Activities -
                    </span>{' '}
                    Claim credits for qualifying research expenses.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-941-schedule-r/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 5,
                    height: '100%',

                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Form 941 Schedule R
                  </Typography>
                  <Typography variant="body1">
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Allocation Schedule for Aggregate Form 941 Filers –
                    </span>{' '}
                    Required for Section 3504 agents, CPEOs, or other
                    third-party payers to allocate wages and taxes for each
                    client.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-941-x-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 5,
                    height: '100%',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Form 941-X
                  </Typography>
                  <Typography variant="body1">
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Adjusted Employer’s Quarterly Federal Tax Return or Claim
                      for Refund –
                    </span>{' '}
                    Used to correct errors on a previously filed Form 941, such
                    as reporting or calculation mistakes in wages, tips, or
                    taxes.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to simplify your quarterly payroll tax filing?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Join thousands of businesses using TaxZerone to file irs Form 941
          quickly, accurately, and securely every quarter.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
          >
            E-file Form 941 Now
          </Button>
          {/* <Typography
              variant="body2"
              sx={{ mt: 1, mb: { xs: 2, md: 0 } }}
              color="#dfeae1"
            >
              Simple. Secure. Accurate.
            </Typography> */}
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
          component="section"
        >
          <Grid size={12}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Helpful Resources for Quarterly Tax Filing
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="/resources/employment-tax/form-941-instructions/"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 0,
                  py: 0,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 0,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/f941-instruction-img.webp" />
                    <source srcSet="/assets/images/f941-instruction-img.png" />
                    <img
                      src="/assets/images/f941-instruction-img.png"
                      alt="Form 941 Instructions"
                      className="partner-card"
                      loading="lazy"
                      width={361}
                      height={292}
                      style={{
                        borderTopRightRadius: 12,
                        borderTopLeftRadius: 12,
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                      textAlign: 'center',
                    }}
                  >
                    Form 941 Instructions
                  </Typography>
                  <Typography variant="body1">
                    Read the TaxZerone’s step-by-step Form 941 instructions to
                    help you file accurately.
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="/resources/employment-tax/form-941-filing-deadlines-and-penalties-guide/"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 0,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/f941-due-date-img.webp" />
                    <source srcSet="/assets/images/f941-due-date-img.png" />
                    <img
                      src="/assets/images/f941-due-date-img.png"
                      alt="Form 941 Due Date"
                      className="partner-card"
                      loading="lazy"
                      width={361}
                      height={292}
                      style={{
                        borderTopRightRadius: 12,
                        borderTopLeftRadius: 12,
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                      textAlign: 'center',
                    }}
                  >
                    Form 941 Due Date
                  </Typography>
                  <Typography variant="body1">
                    Check the Form 941 due date and file it before the deadline
                    with TaxZerone
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="/resources/employment-tax/form-941-mailing-address/"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',

                  backgroundColor: '#f0f2f9',
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 0,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/f941-mail-add-img.webp" />
                    <source srcSet="/assets/images/f941-mail-add-img.png" />
                    <img
                      src="/assets/images/f941-due-date-img.png"
                      alt="Form 941 Mailing Address"
                      className="partner-card"
                      loading="lazy"
                      width={361}
                      height={292}
                      style={{
                        borderTopRightRadius: 12,
                        borderTopLeftRadius: 12,
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                      textAlign: 'center',
                    }}
                  >
                    Form 941 Mailing Address
                  </Typography>
                  <Typography variant="body1">
                    Use the right Form 941 mailing address according to your
                    location when filing by mail.
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={12}
            sx={{ borderTop: ' 1px solid rgba(143, 156, 169, 0.24)', mt: 8 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                mt: 3,
                textAlign: 'center',
              }}
            >
              Recent Blogs
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="https://blog.taxzerone.com/posts/whats-new-in-form-941-for-2026-key-changes-explained/"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    position: 'relative',
                    border: '6px solid #42453f !important',
                    borderRadius: 3,
                    maxHeight: { xs: 183, sm: 134, md: 190, lg: 190 },
                    mb: 2,
                    '& img': {
                      transform: 'scale(1)',
                      transition: 'all .3s ease',
                      //  objectFit: 'cover',
                      width: '100%',
                      height: 'auto',
                    },
                    '& img:hover': { transform: 'scale(1.11)' },
                  }}
                >
                  <img
                    src="https://blog.taxzerone.com/wp-content/uploads/form-941-for-2026-3.png"
                    alt="What’s New in Form 941 for 2026 – Key Changes Explained"
                    width={394}
                    height={247}
                  />
                </Box>
                <Box sx={{ p: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 500,
                      fontSize: { md: 18, sm: 17, xs: 16 },
                      lineHeight: 1.2,
                    }}
                  >
                    {' '}
                    What’s New in Form 941 for 2026 – Key Changes Explained
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="https://blog.taxzerone.com/posts/understanding-form-941-a-comprehensive-guide-for-employers/"
              sx={{ textDecoration: 'none' }}
              target="_blank"
            >
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    position: 'relative',
                    border: '6px solid #42453f !important',
                    borderRadius: 3,
                    maxHeight: { xs: 183, sm: 134, md: 190, lg: 190 },
                    mb: 2,
                    '& img': {
                      transform: 'scale(1)',
                      transition: 'all .3s ease',
                      //  objectFit: 'cover',
                      width: '100%',
                      height: 'auto',
                    },
                    '& img:hover': { transform: 'scale(1.11)' },
                  }}
                >
                  <img
                    src="https://blog.taxzerone.com/wp-content/uploads/form-941-for-2025.png"
                    alt="Understanding Form 941: A Comprehensive Guide for Employers"
                    width={394}
                    height={247}
                  />
                </Box>
                <Box sx={{ p: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 500,
                      fontSize: { md: 18, sm: 17, xs: 16 },
                      lineHeight: 1.2,
                    }}
                  >
                    {' '}
                    Form 941 Guide for Employers: Quarterly Federal Tax Return
                    Explained
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            sx={{ borderTop: ' 1px solid rgba(143, 156, 169, 0.24)', mt: 8 }}
            component="section"
            aria-labelledby="f941-tax-faqs"
          >
            <Typography
              id="f941-tax-faqs"
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mt: 4,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What tax years does TaxZerone support for Form 941?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1, mb: 0 }}>
                      TaxZerone supports Form 941 filing for the current tax
                      year{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        (2026 – Q1, Q2 and Q3)
                      </strong>{' '}
                      as well as prior years{' '}
                      <strong style={{ fontWeight: 600 }}>
                        (2025 and 2024)
                      </strong>
                      . This allows businesses to stay compliant by filing
                      current quarterly returns and catching up on past-due
                      filings in one place, ensuring accurate and timely
                      submissions to the IRS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What are the key differences between the 941 forms for
                  different years?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      The key differences between IRS Form 941 across different
                      years are:
                    </Typography>
                    <Box component="div" sx={{ mb: 1 }}>
                      <TableContainer sx={{ border: '1px solid #828282' }}>
                        <Table sx={{}} aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#ccc' }}>
                              <TableCell
                                sx={{ color: '#444', width: 200, fontSize: 17 }}
                              >
                                Differences
                              </TableCell>

                              <TableCell
                                sx={{ color: '#444', width: 200, fontSize: 17 }}
                              >
                                2026 
                              </TableCell>
                              <TableCell
                                sx={{ color: '#444', width: 200, fontSize: 17 }}
                              >
                                2025
                              </TableCell>
                              <TableCell
                                sx={{ color: '#444', width: 200, fontSize: 17 }}
                              >
                                2024
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow sx={{}}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Social Security wage base
                              </TableCell>
                              <TableCell>$184,500 limit per employee</TableCell>
                              <TableCell>$176,100 limit per employee</TableCell>
                              <TableCell>$168,600 limit per employee</TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Household employee threshold
                              </TableCell>
                              <TableCell>$3,000 in cash wages</TableCell>
                              <TableCell>$2,800 in cash wages</TableCell>
                              <TableCell>$2,700 in cash wages</TableCell>
                            </TableRow>
                            <TableRow sx={{}}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Election worker threshold
                              </TableCell>
                              <TableCell>
                                $2,500 in cash or equivalent compensation
                              </TableCell>
                              <TableCell>
                                $2,400 in cash or equivalent compensation
                              </TableCell>
                              <TableCell>
                                $2,300 in cash or equivalent compensation
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Aggregate filer reporting
                              </TableCell>
                              <TableCell>
                                Dedicated "Aggregate Return Filers Only" section
                              </TableCell>
                              <TableCell>Standard reporting</TableCell>
                              <TableCell>Standard reporting</TableCell>
                            </TableRow>
                            <TableRow sx={{}}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Refund/Banking Layout
                              </TableCell>
                              <TableCell>
                                Expanded lines (15c–15e) for direct deposit
                              </TableCell>
                              <TableCell>Standard lines</TableCell>
                              <TableCell>Standard lines</TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Electronic Form 941 transcripts
                              </TableCell>
                              <TableCell>
                                Available electronically for tax years 2023 and
                                later through an IRS business tax account
                              </TableCell>
                              <TableCell>
                                Not available electronically in the same way
                              </TableCell>
                              <TableCell>
                                Not available electronically in the same
                                way{' '}
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{}}>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Qualified tips provisions
                              </TableCell>
                              <TableCell>
                                2026 instructions reflect new qualified-tip
                                deduction
                              </TableCell>
                              <TableCell>
                                Qualified-tips deduction provisions apply under
                                the 2025 tax law{' '}
                              </TableCell>
                              <TableCell>Not applicable</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                    <Alert
                      severity="warning"

                      icon={false}
                      sx={{ mt: 1, mb: 0, textAlign: 'left' }}
                    >
                      <b>Note:</b> Employers should use the Form 941 revision
                      and instructions applicable to the quarter and year being
                      reported.
                    </Alert>
                  </Box>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Who is not required to file 941 irs form?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1, mb: 0 }}>
                      Learn the situations or employers don't need to file form
                      941:
                    </Typography>
                    <Box component="div" sx={{ mb: 1 }}>
                      <TableContainer sx={{ border: '1px solid #828282' }}>
                        <Table sx={{}} aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#ccc' }}>
                              <TableCell
                                sx={{ color: '#444', width: 200, fontSize: 17 }}
                              >
                                Employer/situation
                              </TableCell>

                              <TableCell
                                sx={{ color: '#444', width: 200, fontSize: 17 }}
                              >
                                Form generally used instead of 941
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow sx={{}}>
                              <TableCell>
                                IRS-notified small employer to file
                                annually{' '}
                              </TableCell>

                              <TableCell>
                                <Link
                                  href="/employment-tax/e-file-irs-form-944/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Form 944
                                </Link>{' '}
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell>Household employer </TableCell>

                              <TableCell>Schedule H (Form 1040)</TableCell>
                            </TableRow>
                            <TableRow sx={{}}>
                              <TableCell>Agricultural employer</TableCell>

                              <TableCell>Form 943</TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell>
                                Seasonal employer with no wages to report for a
                                quarter
                              </TableCell>

                              <TableCell>
                                No Form 941 for that quarter
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  How to determine if you are a Form 941 semiweekly deposit
                  scheduler?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      To determine if you are a Form 941 semiweekly deposit
                      scheduler:
                    </Typography>
                    <ul>
                      <li style={{ marginBottom: 16 }}>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Lookback Period:
                        </strong>{' '}
                        You reported more than $50,000 in Form 941 taxes during
                        the 12-month lookback period ending June 30 of the prior
                        year.
                      </li>
                      <li style={{ marginBottom: 16 }}>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          $100,000 Threshold:
                        </strong>{' '}
                        If you accumulate $100,000 or more in tax liability on
                        any day during a deposit period.
                      </li>
                    </ul>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  How can I correct mistakes on a previously filed irs tax form
                  941?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1, mb: 2 }}>
                      To correct mistakes on a previously filed irs 941 form,
                      you need to{' '}
                      <Link
                        href="/employment-tax/efile-irs-form-941-x-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        file Form 941-X
                      </Link>
                      , which is the Adjusted Employer’s Quarterly Federal Tax
                      Return or Claim for Refund. This form allows you to fix
                      errors like incorrect wages, tax amounts, or deposit
                      mistakes.
                    </Typography>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{
                        mb: 2,
                        fontSize: 13,
                        borderLeft: '3px solid rgb(102, 60, 0)',
                      }}
                    >
                      <b> Note:</b> It’s important to submit this as soon as you
                      discover the error to avoid penalties or interest.
                    </Alert>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-941/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form941;
